import { useLocation, useParams } from 'react-router-dom'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import Form from 'base/Form'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { useEffect, useState } from 'react'
import { Toast } from 'primereact/toast'

export default function FormCadastro(props) {

    const { service, children, form, aux, toast } = props

    const navigate = useNavigate()
    const pesquisa = useLocation()
    const { id } = useParams()
    const [saving, setSaving] = useState(false)

    /**
     * form.formState.isDirty = Passa para true mas não volta para false 'porque' é um boolean.
     * form.formState.dirtyFields = Campos alterados, são removidos caso voltem ao original.
     * 
     */

    const isFormEdited = form.formState.isDirty

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        handleValidationError()
    }, [form.formState.errors])

    const handleValidationError = () => {

        if (Object.keys(form.formState.errors).length > 0) {
            console.log("Validation error:", form.formState.errors)
            if (props.onValidationError) {
                props.onValidationError()
            } else {

                if (props.toast) {
                    props.toast.current.show({
                        severity: 'info', summary: 'Preenchimentos',
                        detail: 'Verifique os campos marcados com asteríscos!', life: 3000
                    })
                }
            }
        }

    }

    useEffect(_ => {
        document.title = service.title + (id ? ' ' + id : ' (Novo)')
    }, [])


    /**
     * Submit, caso tenham problemas no schema onSubmit não é disparado!
     * @param {*} data 
     */
    function onSubmit(data) {

        console.log('FormCadastro.onSubmit:', data)

        let dataCopy = { ...data }
        console.log('Submiting (B) ')

        if (typeof props.beforeSubmit === 'function') {
            dataCopy = props.beforeSubmit(dataCopy)
            if (dataCopy === false) {
                return false
            }
        }

        console.log('Submiting: ', dataCopy)

        confirmDialog({
            message: 'Confirma salvar?',
            icon: 'pi pi-question-circle',
            accept: () => {

                /**
                 * Se o dev informar a função onSave então ela será chamada
                 * no lugar do service e o dev terá que implementar a função onSave()
                 * 
                 */

                setSaving(true)

                if (typeof props?.onSave === 'function') {
                    props.onSave({ id, dataCopy, navigate, pesquisa, setSaving })
                } else {
                    service.save(id, dataCopy).then(async (_response) => {
                        console.log('Inside formCadastro:', _response)
                        navigate(service.frontUrlList, pesquisa)
                    }).catch((err) => {
                        aux.showExceptions(err)
                    }).finally(_ => setSaving(false))
                }

            }
        })

    }

    const handleCancel = (e) => {

        const cancelEvent = () => {
            if (props.onCancel) {
                props.onCancel()
            } else {
                navigate(service.frontUrlList, pesquisa)
            }
        }

        const dirty = Object.keys(form.formState.dirtyFields).length > 0

        if (dirty) { // isFormEdited
            confirmDialog({
                message: 'Confirma abandonar a edição?',
                icon: 'pi pi-question-circle',
                accept: () => {
                    cancelEvent()
                }
            })
        } else {
            cancelEvent()
        }

        e.preventDefault()
    }

    function getFullTitle() {

        let fullTitle = service.title.toUpperCase()

        fullTitle += id ? ' (Código ' + id + ')' : ' (Novo)'

        fullTitle += ' ' + (form.formState.isDirty ? ' *' : '')

        return fullTitle
    }

    return (

        < Form form={form} onSubmit={onSubmit} title={getFullTitle()} icon={service.icon}>
            <Toast ref={toast} />
            <ConfirmDialog />
            {children}
            <div className="mt-4 flex gap-2 justify-content-end" >
                <Button
                    id='bntFormSave'
                    label={saving ? 'Salvar' : 'Salvar'}
                    icon={saving ? "pi pi-spin pi-cog" : "pi pi-save"}
                    severity="primary"
                    size="normal"
                    disabled={!isFormEdited}
                    type='submit'
                    onAuxClick={e => {
                        console.log('onAuxClick')
                    }}
                    onBlur={props.saveOnBlur}
                    onClick={props.saveOnClick}
                />
                <Button id='bntFormBack' label="Voltar" size="normal" icon="pi pi-arrow-left" severity="success" onClick={handleCancel} />
            </div >


        </Form >
    )
}

export class FormCadastroAux {
    static toast

    static async load({ id = 'new', service, toast, useNew }) {

        let rs = { data: {} }
        this.toast = toast

        if (id === 'new') {
            if (useNew) {
                rs = await service.getById({ id })
            }
        } else {
            rs = await service.getById({ id })
        }

        if (this.hasErrorsShow(rs)) {
            return {}
        } else {
            return rs.data
            // const data = rs.data
            // return service.prepareToFront(data)
        }

    }

    static hasErrorsShow = (rs) => {
        const data = rs.response?.data

        const hasErrors = (data && data.messages?.errors) ||
            (data && data.messages?.error) ||
            (data && data.error)

        if (hasErrors) {
            this.showExceptions(rs)
        }

    }

    /**
     * Extrair essa função para reuso
     */
    static showExceptions = (rs, toast) => {
        const data = rs.response?.data
        let messages = ''

        if (typeof data == 'object') {

            const arrayErros = data?.messages?.errors || data?.messages

            if (arrayErros) {
                const msgError = arrayErros
                if (Array.isArray(msgError)) {

                    messages = ''
                    msgError.map(e => {

                        messages += e.message.replace('{{ field }}', e.field) + '.'
                        return ''
                    })

                }
            } else if (data && typeof data?.error == 'string') {
                messages += data.error
            }
        } else if (typeof data == 'string') {
            messages = data
        }

        if (!messages && rs?.message) {
            messages = rs.message + '. '
        }

        if (data?.message?.length > 0) {
            messages = data?.message
        }

        this.toast = this.toast || toast

        const objToast = { severity: 'error', summary: 'Ops!', detail: 'Mensagem técnica: ' + messages, life: 7000 }

        console.log('toast:', rs)
        if (this.toast.current) {
            this.toast.current.show(objToast)
        }


    }
}
